import { useTranslation } from 'react-i18next';

import { Button, Form, Input } from '@arco-design/web-react';
import { useCallback } from 'react';
import { login } from '../service';

const FormItem = Form.Item;
const primaryBtnStyle: React.CSSProperties = {
  fontWeight: 600,
  borderRadius: '4px',
  marginTop: 16,
};

export default function Standard({ onSuccess }) {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const handleLogin = useCallback(() => {
    form
      .validate()
      .then((values) => {
        login(values).then(onSuccess);
      })
      .catch(() => {});
  }, [form, onSuccess]);

  return (
    <Form form={form} layout="vertical">
      <FormItem
        field="condition"
        rules={[{ required: true, message: t('login-page:account.cannot.be.empty') }]}
      >
        <Input
          placeholder={t('login-page:please.enter.username.mobile.number.or.email')}
          onPressEnter={handleLogin}
        />
      </FormItem>
      <FormItem
        field="password"
        rules={[{ required: true, message: t('login-page:password.cannot.be.empty') }]}
      >
        <Input.Password
          placeholder={t('common:please.enter.password')}
          onPressEnter={handleLogin}
        />
      </FormItem>
      <Button long type="primary" style={primaryBtnStyle} onClick={handleLogin}>
        {t('login-page:login')}
      </Button>
    </Form>
  );
}
